import React from "react";
import { Link, navigate } from "gatsby";
import { IoIosInfinite, IoIosInformationCircleOutline } from "react-icons/io";
import { FiArrowLeft, FiCheck, FiX } from "react-icons/fi";

import isBrowser from "../utils/isBrowser";
import { plans } from "../utils/plans";

const Plan = ({ ...plan }) => (
    <div css={{
        width: 250,
        minWidth: 250,
        margin: 25,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: 3,
        backgroundColor: "rgba(100, 100, 100, .1)",
        boxShadow: plan.available ? "0px 10px 30px -10px black" : "0px 5px 15px -5px black",
    }}>
        <div css={{
            height: 100,
            padding: 15,
            backgroundColor: "rgba(100, 100, 100, .1)",
            borderRadius: 3,
            opacity: plan.available ? 1 : .3,
        }}>
            <div css={{
                fontWeight: 500,
                marginBottom: 5,
            }}>
                { plan.name }
            </div>
            <div css={{
                fontSize: ".8em",
                color: "darkgrey",
            }}>
                { plan.description }
            </div>
        </div>

        <div css={{
            padding: 25,
            fontSize: ".8em",
            opacity: plan.available ? 1 : .3,
        }}>
            {
                plan.benefits.prev
                ?   <div css={{
                        display: "flex",
                        marginBottom: 5,
                        textAlign: "left",
                    }}>
                        <FiArrowLeft css={{ minWidth: 15, marginRight: 10, color: "var(--green)" }} />
                        <div>Everything in { plan.benefits.prev }</div>
                    </div>
                :   null
            }
            {
                plan.benefits.unlimited
                ?   plan.benefits.unlimited.map((benefit, i) =>
                        <div key={ i } title={ (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? "Coming Soon" : "" } css={{
                            display: "flex",
                            marginBottom: 5,
                            textAlign: "left",
                            opacity: (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? .5 : 1,
                        }}>
                            <IoIosInfinite css={{ minWidth: 15, marginRight: 10, color: "var(--blue)" }} />
                            <div>{ (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? (benefit instanceof Array ? benefit[0] : benefit).slice(1) : (benefit instanceof Array ? benefit[0] : benefit) }</div>
                        </div>
                    )
                :   null
            }
            {
                plan.benefits.available
                ?   plan.benefits.available.map((benefit, i) =>
                        <div key={ i } title={ (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? "Coming Soon" : "" } css={{
                            display: "flex",
                            marginBottom: 5,
                            textAlign: "left",
                            opacity: (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? .5 : 1,
                        }}>
                            <FiCheck css={{ minWidth: 15, marginRight: 10, color: "var(--green)" }} />
                            <div>
                                { (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? (benefit instanceof Array ? benefit[0] : benefit).slice(1) : (benefit instanceof Array ? benefit[0] : benefit) }
                                {
                                    benefit instanceof Array && benefit.length > 1
                                    ?   <IoIosInformationCircleOutline css={{ marginLeft: 5, color: "var(--blue)" }} title={ benefit[1] } />
                                    :   null
                                }
                            </div>
                        </div>
                    )
                :   null
            }
            {
                plan.benefits.unavailable
                ?   plan.benefits.unavailable.map((benefit, i) =>
                        <div key={ i } title={ (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? "Coming Soon" : "" } css={{
                            display: "flex",
                            marginBottom: 5,
                            textAlign: "left",
                            opacity: (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? .5 : 1,
                        }}>
                            <FiX css={{ minWidth: 15, marginRight: 10, color: "var(--red)" }} />
                            <div>{ (benefit instanceof Array ? benefit[0] : benefit).startsWith("~") ? (benefit instanceof Array ? benefit[0] : benefit).slice(1) : (benefit instanceof Array ? benefit[0] : benefit) }</div>
                        </div>
                    )
                :   null
            }
        </div>

        <div css={{
            padding: 20,
            fontSize: ".8em",
            fontWeight: 500,
            fontFamily: "monospace",
            borderRadius: 3,
            backgroundColor: "rgba(100, 100, 100, .1)",
            color: "var(--green)",
        }}>
            {
                plan.available
                ?   plan.price === 0
                    ?   "Free"
                    :   "$" + plan.price + " / mo."
                :   "Coming Soon"
            }
        </div>
    </div>
);

const Bubble = ({ size = 10, top = 0, left = 0 }) => (
    <div css={{
        top,
        left,
        position: "absolute",
        padding: size,
        borderRadius: Math.random() > 0.5 ? "50%" : 0,
        transform: Math.random() > 0.5 ? "rotateZ(30deg)" : "rotateZ(120deg)",
        backgroundColor: "var(--green)",
    }} />
);

const DummyFeedback = ({ closed }) => (
    <div css={{
        margin: 20,
    }}>
        <div css={{
            width: "80%",
            marginBottom: 5,
            padding: 8,
            borderRadius: 3,
            backgroundColor: "rgba(200, 200, 200, .3)",
        }} />
        <div css={{
            width: 100,
            marginBottom: 5,
            padding: 8,
            borderRadius: 3,
            backgroundColor: closed ? "var(--red)" : "var(--blue)",
        }} />
        <div css={{
            width: "100%",
            marginBottom: 5,
            padding: 8,
            borderRadius: 3,
            backgroundColor: "rgba(200, 200, 200, .2)",
        }} />
        <div css={{
            width: "50%",
            marginBottom: 5,
            padding: 8,
            borderRadius: 3,
            backgroundColor: "rgba(200, 200, 200, .2)",
        }} />
    </div>
);

const DummyApp = () => (
    <div css={{
        position: "relative",
        display: "flex",
        borderRadius: 13,
        backgroundColor: "rgba(100, 100, 100, .3)",
        boxShadow: "0px 15px 50px -10px black",
    }}>
        <div
            css={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translateX(-50%) translateY(-50%)",
                backgroundColor: "var(--green)",
                color: "black",
                padding: "10px 20px",
                borderRadius: "50px",
                fontWeight: 500,
                boxShadow: "0px 0px 30px -10px rgba(0, 0, 0, 1)",
                border: "1px solid var(--green)",
                cursor: "pointer",
                transition: "border var(--transition-default-time) ease-out",
                ":hover": {
                    border: "3px solid var(--green)",
                },
                ":active": {
                    border: "2px solid var(--green)",
                },
            }}
            onClick={ () => navigate("/glee") }
        >
            See how it works
        </div>

        <div css={{
            flex: 2,
            margin: 30,
        }}>
            <DummyFeedback />
            <DummyFeedback closed={ true } />
            <DummyFeedback />
            <DummyFeedback />
        </div>

        <div css={{
            flex: 1,
            marginTop: 50,
            borderTopLeftRadius: 5,
            borderBottomRightRadius: 13,
            backgroundColor: "rgba(100, 100, 100, .5)",
        }}>
            <div css={{
                height: 30,
                margin: "20px 20px 10px",
                padding: 8,
                borderRadius: 3,
                backgroundColor: "rgba(0, 0, 0, .5)",
            }} />
            <div css={{
                height: 100,
                margin: "10px 20px",
                padding: 8,
                borderRadius: 3,
                backgroundColor: "rgba(0, 0, 0, .5)",
            }} />
            <div css={{
                height: 30,
                margin: "10px 20px",
                padding: 8,
                borderRadius: 3,
                backgroundColor: "rgba(20, 20, 20, .5)",
            }} />
        </div>
    </div>
);

export default () => {
    const bubbles = [
        { size: 3, top: "20%", left: "70%" },
        { size: 3, top: "90%", left: "-20%" },
        { size: 6, top: "40%", left: "10%" },
        { size: 6, top: "90%", left: "80%" },
        { size: 9, top: 0, left: 0 },
        { size: 9, top: "40%", left: "120%" },
        { size: 13, top: "80%", left: "30%" },
    ];

    return (
        <div css={{
            padding: 20,
            display: "flex",
            flexDirection: "column",
        }}>
            <div css={{
                position: "relative",
                maxWidth: 720,
                minHeight: "50vh",
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
            }}>
                {
                    bubbles.map((bubble, i) =>
                        <Bubble size={ bubble.size } top={ bubble.top } left={ bubble.left } />
                    )
                }
                <div css={{
                    fontSize: "2.5em",
                    fontWeight: 700,
                    marginBottom: 30,
                    zIndex: 1,
                }}>
                    Collect feedback and make great products
                </div>
                <div css={{
                    zIndex: 1,
                }}>
                    Whether you're a startup, a solo developer, an artist, a creator, or just a handful of friends
                    building a great product or creating interesting content,
                    Glee makes it easy to collect, track and manage feedback from your users.
                </div>
                <div css={{
                    zIndex: 1,
                    margin: "30px 20px",
                }}>
                    <button
                        css={{
                            fontWeight: 500,
                            backgroundColor: "var(--green)",
                            boxShadow: "0px 15px 50px -10px black",
                            ":active": {
                                filter: "saturate(80%)",
                            },
                        }}
                        onClick={ () => isBrowser() ? window.scroll({
                            top: 950,
                            behavior: "smooth",
                        }) : {} }
                    >
                        Dive in
                    </button>
                </div>
            </div>

            <DummyApp />

            <div css={{
                marginTop: 100,
                textAlign: "center",
            }}>
                <div css={{
                    fontSize: "1.5em",
                    marginBottom: 15,
                }}>
                    Plans
                </div>
                <div css={{
                    marginBottom: 30,
                    color: "lightgrey",
                }}>
                    Compare the available plans and choose the right one for you. Get started for free, upgrade later.
                </div>
                <div css={{
                    margin: "50px 0",
                    display: "flex",
                    backgroundColor: "var(--dark)",
                    overflowX: "auto",
                    scrollbarWidth: "thin",
                }}>
                    {
                        plans.map(plan =>
                            <Plan key={ plan.id } { ...plan } />
                        )
                    }
                </div>
                <div css={{
                    marginBottom: 100,
                    color: "darkgrey",
                    "a": {
                        color: "var(--green)",
                    },
                }}>
                    When you upgrade your plan, changes are applied immediately. When you downgrade your plan, changes are applied at the end of your current billing cycle. If you've any further questions regarding this, feel free to <Link to="/contact">contact us</Link>.
                </div>
                <div>
                    <div css={{
                        fontSize: "1.3em",
                        fontWeight: 700,
                        color: "lightgrey",
                    }}>
                        Are you ready for it?
                    </div>
                    <div css={{
                        margin: 20,
                    }}>
                        <button
                            css={{
                                fontWeight: 500,
                                backgroundColor: "var(--green)",
                                boxShadow: "0px 15px 50px -10px black",
                                ":active": {
                                    filter: "saturate(80%)",
                                },
                            }}
                            onClick={ () => navigate("/authorize") }
                        >
                            Let's Start
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
